import XLSX from "xlsx";

//this is where we add the logic for determiniing the phase, input and output volt options.

export function invSelAlgo(path, sheetnum) {
  return fetch(path)
    .then((response) => response.arrayBuffer())
    .then((data) => {
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[sheetnum]; // Assuming the first sheet
      const worksheet = workbook.Sheets[sheetName];
      const opdata = XLSX.utils.sheet_to_json(worksheet);

      return opdata;
    })
    .catch((error) => {
      throw new Error("Failed to read file: " + error.message);
    });
}

export default invSelAlgo;
